module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGa98c8059fce28fb99b7d4859de05bae6.a98c8059.png";